// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const options = {
  order: ['path', 'cookie', 'localStorage', 'htmlTag', 'subdomain'],
  caches: ['cookie'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    debug: true,
    detection: options,
    supportedLngs: ['en-us','en-ua', 'ko-kr', 'pt-br', 'th-th', 'zh-cn', 'zh-tw', 'ja-jp', 'fr-fr', 'ar-sa', 'de-de', 'en-ap', 'de-at', 'en-gb', 'el-gr', 'cs-cz', 'en-sa', 'en-ae', 'en-au', 'en-ca', 'en-id', 'en-ie', 'en-il', 'en-kw', 'en-kz', 'en-sg', 'en-th', 'en-tr', 'es-es', 'en-ua', 'en-za', 'fr-ca', 'it-it', 'nl-nl', 'en-se', 'pl-pl', 'ru-ru', 'en-in', 'es-la', 'hr-hr', 'in-id', 'en-ae', 'en-kw', 'en-kz', 'en-za', 'tr-tr', 'id-id'],
    lowerCaseLng: true,
    load: 'currentOnly',
    fallbackLng: (code) => {
      const c = (code || '').toLowerCase();
      // If detector found a language (e.g., ja-jp), don't load fallback.
      // If nothing detected, fallback to en-us.
      return c ? [] : ['en-us'];
    },
    languageAliases: {
      'id-id': 'in-id',
    },
    backend: {
      loadPath: (languages, namespaces) => {
        const lng = Array.isArray(languages) ? languages[0] : languages;
        const ns  = Array.isArray(namespaces) ? namespaces[0] : (namespaces || 'translation');
        const normalized = String(lng || 'en-us').toLowerCase();
        return `/locales/${normalized}/${ns}.json`;
      },
    },
  });

export default i18n;